import TagPills from '../TagPills/TagPills';
import './InitiativeCard.css';

export default function InitiativeCard({
  title,
  description,
  tags = [],
  tagPosition = 'top',
  showArrow = true,
}) {
  const isBottom = tagPosition === 'bottom';

  return (
    <article className={`InitiativeCard ${showArrow ? 'InitiativeCard--withArrow' : ''}`}>
      {showArrow ? <span className="InitiativeCard__arrow" aria-hidden="true" /> : null}

      {!isBottom ? <TagPills tags={tags} position="top" /> : null}
      {title ? <h4 className="InitiativeCard__title">{title}</h4> : null}
      {description ? <p className="InitiativeCard__description">{description}</p> : null}
      {isBottom ? <TagPills tags={tags} position="bottom" /> : null}
    </article>
  );
}
